if (!window.localizationLanguageFirstInitialized) {
  window.localizationLanguageFirstInitialized = true;

  document.addEventListener('click', async (event) => {
    const languageOption = event.target.closest('[data-localization-language-option]');

    if (!languageOption) {
      return;
    }

    event.preventDefault();

    const languagePopover = languageOption.closest('x-popover[data-localization-type="locale"]');
    const groupId = languagePopover?.dataset.localizationGroupId;

    if (!languagePopover || !groupId) {
      return;
    }

    const countryPopovers = Array.from(
      document.querySelectorAll('x-popover[data-localization-type="country"]')
    ).filter((popover) => popover.dataset.localizationGroupId === groupId);

    const countryPopover = countryPopovers.find((popover) => {
      const control = document.querySelector(`[aria-controls="${CSS.escape(popover.id)}"]`);
      return control && control.offsetParent !== null;
    }) || countryPopovers[0];

    if (!countryPopover) {
      return;
    }

    const languageCode = languageOption.value;
    const languageName = languageOption.dataset.languageName;

    document.querySelectorAll('x-popover[data-localization-type="locale"]').forEach((popover) => {
      if (popover.dataset.localizationGroupId !== groupId) {
        return;
      }

      popover.querySelectorAll('[data-localization-language-option]').forEach((option) => {
        option.setAttribute('aria-selected', option.value === languageCode ? 'true' : 'false');
      });

      const trigger = document.querySelector(`[aria-controls="${CSS.escape(popover.id)}"]`);
      const label = trigger?.querySelector('[data-localization-language-label]');

      if (label && languageName) {
        label.textContent = languageName;
      }
    });

    const languageInput = countryPopover.querySelector('[data-localization-language-input]');
    languageInput.disabled = false;
    languageInput.value = languageCode;

    const countryOptions = Array.from(
      countryPopover.querySelectorAll('[data-localization-country-option]')
    );

    countryOptions.forEach((option) => {
      option.hidden = !option.dataset.languageCodes.includes(`|${languageCode}|`);
    });

    const selectedCountry = countryOptions.find(
      (option) => !option.hidden && option.getAttribute('aria-selected') === 'true'
    ) || countryOptions.find((option) => !option.hidden);

    countryOptions.forEach((option) => {
      option.setAttribute('aria-selected', option === selectedCountry ? 'true' : 'false');
    });

    await languagePopover.hide();
    await countryPopover.show();
  });
}
